<div class="three-dots-blinking">
  <span></span>
  <span></span>
  <span></span>
</div>
